import { PlanType } from '../../../graphQL/generated/enums'

export const NEW_PROS_DATE = '2023-04-02'
export const SSPROSDISCOUNTCODE = 'SECRETSPAPROS-11-23'
export const EntitlementId = {
  BOOKING_SYSTEM: 'booking-system',
  WEBSITE_BUILDER: 'advanced-website',
  SALON_MEMBER: 'salon-member-seat',
} as const
export type EntitlementIdType = (typeof EntitlementId)[keyof typeof EntitlementId]
// The object makes sure if a plan is added as a type, it will show an error if not added here
export const priorityOrderObject: Record<PlanType, number> = {
  [PlanType.Elite]: 0,
  [PlanType.Pro]: 1,
  [PlanType.Website]: 2,
  [PlanType.Grow]: 3,
  [PlanType.Starter]: 4,
  [PlanType.Unknown]: 5,
}
export const entitlementGracePeriods = {
  [EntitlementId.BOOKING_SYSTEM]: 3,
  [EntitlementId.WEBSITE_BUILDER]: 14,
  [EntitlementId.SALON_MEMBER]: 0,
} as const
export const priorityOrder = Object
  .keys(priorityOrderObject)
  .sort((a, b) => priorityOrderObject[a as PlanType] - priorityOrderObject[b as PlanType]) as PlanType[]
export const plansToHide = [PlanType.Grow, PlanType.Starter, PlanType.Elite]
export const soloAppPlans = [PlanType.Pro, PlanType.Grow, PlanType.Website]